import React from 'react';

interface Props {
  size: number;
}

const RainDropIcon = (props: Props) => {
  const { size } = props;
  return (

    <svg width={size} height={size} viewBox="0 0 100 117" xmlns="http://www.w3.org/2000/svg" version="1.1">
      <path id="Tracé" d="M6.75 68.946 C6.75 76.635 8.667 83.822 12.583 90.424 16.5 97.026 21.75 102.375 28.417 106.303 35.083 110.231 42.25 112.236 50 112.236 57.75 112.236 65 110.231 71.75 106.303 78.5 102.375 83.833 97.026 87.75 90.424 91.667 83.739 93.667 76.635 93.667 68.946 93.667 63.932 92.25 57.999 89.333 51.062 86.417 44.126 82.917 37.691 78.833 31.841 75.167 27.077 70.833 21.812 65.833 16.129 60.833 10.446 52.083 1.671 50.083 -0.334 L39.417 10.446 C34.25 15.461 29.25 21.227 24.5 27.829 19.75 34.431 15.583 41.535 12.083 49.14 8.417 56.745 6.75 63.347 6.75 68.946 Z" fill="#5dadec" fillOpacity="1" stroke="none" />
    </svg>

  );
};

export default RainDropIcon;
